import Alerts from './Alerts';
import { AlertsType } from './AlertsType';

export default Alerts;
export { AlertsType };
